<template>
  <div class="home">
    <my-head></my-head>

    <div class="block bll">
      <el-carousel height="25vw">
        <el-carousel-item v-for="(item, index) in chart" :key="index">
          <a :href="item.url" target="_blank" rel="noopener noreferrer">
            <img :src="item.image" />
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="business">
      <!-- 我要受让 -->
      <div class="busine">
        <div class="text flex-left-center">
          <img style="width: 24px; margin-right: 10px" src="../assets/shopping.png" />
          <div style="
              font-size: 24px;
              font-weight: bold;
              color: #1d2129;
              line-height: 32px;
            ">
            我要受让
          </div>
          <!-- <div style="font-size: 14px; font-weight: 400; color: #86909c">
            国际运营平台，放心保证
          </div> -->
        </div>

        <div class="input">
          <el-input placeholder="请输入关键字,例如:专利,外观" class="input-with-select" v-model="input3" :validate-event="false"
            @input="(e) => (input3 = $validForbid(e))">
          </el-input>

          <el-button suffix-icon slot="append" icon="el-icon-search" class="search" @click="searchInput3">搜索专利
          </el-button>
          <div class="imgpng">
            <img style="width: 15.37px" src="../assets/search.png" />
          </div>
        </div>

        <div class="types">
          <div>计算机</div>
          <div>松茸</div>
          <div>生物医药</div>
          <div>汽车</div>
        </div>
      </div>

      <!-- 我要转让 -->
      <div class="giveway">
        <div class="text2">
          <div class="flex-left-center">
            <img style="width: 24px; margin-right: 20px" src="../assets/Frame.png" />
            <div style="
                font-size: 24px;
                color: #1d2129;
                line-height: 32px;
                font-weight: bold;
              ">
              我要转让
            </div>
          </div>

          <div style="font-size: 14px; font-weight: 400; color: #86909c">
            <!-- 国际平台 -->
          </div>
        </div>

        <div class="roomturn">
          <div class="room" @click="Way">
            <div class="roomdiv">
              <img src="../assets/room.png" />
              <div>我要转让</div>
            </div>
          </div>
          <!-- <div class="turn">
            <div class="turndiv">
              <img src="../assets/turn.png" />
              <div style="cursor: pointer">专利估值</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="surface">
      <div class="surfa" v-for="(item, index) in surfac" :key="index">
        <div class="fors">
          <div>
            <img style="width: 72px" :src="item.image" />
          </div>
          <div class="picture">
            <div style="font-size: 18px; color: #4e5969">
              {{ item.title }}
            </div>
            <div style="
                font-size: 32px;
                color: #1d2129;
                line-height: 38px;
                margin-top: 8px;
              " v-html="item.numb"></div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 挂牌项目 -->
    <div class="headlines">
      <div class="fire">
        <img style="width: 24px; height: 24px; margin-right: 12px" src="../assets/fire.png" />
        <div style="font-weight: 600; font-size: 24px; padding-right: 32px">
          挂牌项目
        </div>
        <el-tabs v-if="editableTabs.length > 0" @tab-click="tabs" :tab-position="tabPosition" v-model="editableTabsValue">
          <el-tab-pane v-for="(item, index) in editableTabs" :key="index" :label="item" :name="String(item)">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div>
        <p @click="seemore" style="font-size: 12px; color: #165dff; cursor: pointer">
          查看更多>
        </p>
      </div>
    </div>

    <div class="lie_biao flex-between-left flex-wrap details">
      <list-card :obj="item" v-for="(item, index) in introduction" :key="index">
      </list-card>
      <div class="no_card"></div>
    </div>

    <div class="headlines" style="margin-top: 80px">
      <div class="fire">
        <img style="width: 24px; height: 24px; margin-right: 12px" src="../assets/Journalism.png" />
        <div style="font-weight: 600; font-size: 24px; padding-right: 32px">
          新闻
        </div>
        <el-tabs v-if="paneTabs.length > 0" :tab-position="tabPosition" v-model="itemPane" @tab-click="tabpane">
          <el-tab-pane v-for="(item, index) in paneTabs" :key="index" :label="item.namePane"
            :name="String(item.idPane)"></el-tab-pane>
        </el-tabs>
      </div>

      <div v-show="itemPane == 0">
        <p style="font-size: 12px; color: #165dff; cursor: pointer" @click="$router.push('/newslist')">
          查看更多>
        </p>
      </div>

      <div v-show="itemPane == 1">
        <p style="font-size: 12px; color: #165dff; cursor: pointer" @click="$router.push('/notilist')">
          查看更多>
        </p>
      </div>
    </div>

    <!-- 新闻 -->
    <div class="adverti" v-show="itemPane == 0">
      <div class="topping">
        <!-- 新闻加图片 -->
        <router-link :to="'/nes?id=' + item.id" v-for="(item, index) in ness" :key="index">
          <div class="advess">
            <div style="width: 73.61%">
              <div class="line-two advess_title">
                {{ item.title }}
              </div>
              <div class="adve">
                <div v-if="item.isUp == 1" style="color: #eb5757; margin-right: 8px">
                  置顶
                </div>
                <div style="color: #86909c">
                  {{ item.createTime | formatDate }}
                </div>
              </div>
            </div>

            <el-image style="
                width: 35.7%;
                height: 78px;
                margin-left: 16px;
                border-radius: 4px;
              " :src="item.imageUrl" fit="cover"></el-image>
          </div>
          <!--  v-if="index !== ness.length - 1" 判断最后一条线消失 -->
          <div class="bor1" style="margin: 24px 0" v-if="index !== ness.length - 1"></div>
        </router-link>
      </div>
      <!-- 新闻 轮播图-->
      <div class="focusNews">
        <el-image style="
            width: 100%;
            height: 379px;
            margin-bottom: 24px;
            border-radius: 12px;
          " :src="topNes.imageUrl" fit="cover"></el-image>

        <div class="news">
          <div style="color: #165dff; padding: 1px 6px; background-color: #e8f3ff">
            要闻
          </div>
          <div style="color: #86909c; margin-left: 8px">
            {{ topNes.createTime | formatDate }}
          </div>
        </div>
        <div class="focus line">
          <router-link style="color: #1d2129" :to="'/nes?id=' + topNes.id">
            {{ topNes.title }}
          </router-link>
          <!-- <span>{{ topNes.title }}</span> -->
        </div>
      </div>
    </div>

    <!-- 公告 -->
    <div class="adverti" v-show="itemPane == 1">
      <div class="topping">
        <!-- 公告加图片 -->
        <router-link :to="'/noti?id=' + item.id" v-for="(item, index) in Noti" :key="index">
          <div class="advess">
            <div style="width: 73.61%">
              <div class="line-two advess_title">
                {{ item.title }}
              </div>
              <div class="adve">
                <div v-if="item.isUp == 1" style="color: #eb5757; margin-right: 8px">
                  置顶
                </div>
                <div style="color: #86909c">
                  {{ item.createTime | formatDate }}
                </div>
              </div>
            </div>

            <el-image style="
                width: 35.7%;
                height: 78px;
                margin-left: 16px;
                border-radius: 4px;
              " :src="item.imageUrl" fit="cover"></el-image>
          </div>

          <div class="bor1" style="margin: 24px 0" v-if="index !== ness.length - 1"></div>
        </router-link>
      </div>
      <!-- 公告 轮播图-->
      <div class="focusNews">
        <el-image style="
            width: 100%;
            height: 379px;
            margin-bottom: 24px;
            border-radius: 12px;
          " :src="topNoti.imageUrl" fit="cover"></el-image>

        <div class="news">
          <div style="color: #165dff; padding: 1px 6px; background-color: #e8f3ff">
            要闻
          </div>
          <div style="color: #86909c; margin-left: 8px">
            {{ topNoti.createTime | formatDate }}
          </div>
        </div>
        <div class="focus line">
          <router-link style="color: #1d2129" :to="'/noti?id=' + topNoti.id">
            {{ topNoti.title }}
          </router-link>
          <!-- <span>{{ topNoti.title }}</span> -->
        </div>
      </div>
    </div>

    <!-- 服务保障 -->
    <div class="Serntee">
      <div class="guarantee">
        <!-- <div class="blank">√</div> -->
        <img class="blank" src="../assets/认证.png" />
        <div style="
            font-size: 24px;
            font-weight: bold;
            color: #1d2129;
            margin-left: 15px;
          ">
          服务保障
        </div>
      </div>
      <div class="overseas">
        <div class="service gray_shadow" v-for="(item, index) in service" :key="index" @click="toUrl(item.url)">
          <div style="padding: 0 25px">
            <img style="width: 48px" :src="item.image" />
            <div style="margin: 10px 0; font-size: 18px; font-weight: 500">
              {{ item.text1 }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 重点产业 -->
    <div class="keyind">
      <div class="akey">
        <div style="
            font-weight: bold;
            color: #1d2129;
            line-height: 32px;
            font-size: 24px;
          ">
          重点产业
        </div>
        <div class="industry">
          <div class="imgs1" v-for="(item, index) in imgList" :key="index" :style="{
            background: `url(${item.img1})`,
            backgroundSize: '100% 100%',
          }" @click="toKey(item.type)">
            <div class="locat">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="recommend">
        <div style="
            font-size: 24px;
            font-weight: bold;
            color: #1d2129;
            line-height: 32px;
          ">
          服务推荐
        </div>
        <div class="bor2"></div>
        <div class="bigdata">
          <div class="big">大数据</div>
          <a href="http://sh.publicdi.com/BigScreen/shanghai.htm" target="_blank"
            style="color: #86909c; font-size: 14px">查看更多></a>
        </div>
        <div class="bor1"></div>
        <div class="bigdata">
          <div class="big">IP咨询</div>
          <router-link style="color: #86909c; font-size: 14px" to="/consult">查看更多></router-link>
        </div>
        <div class="bor1"></div>
        <div class="bigdata">
          <div class="big">IP托管</div>
          <router-link style="color: #86909c; font-size: 14px" to="/trusteeship">查看更多></router-link>
        </div>
        <div class="bor1"></div>
        <div class="bigdata">
          <div class="big">IP运营开发</div>
          <router-link style="color: #86909c; font-size: 14px" to="/operationaldevelopment">查看更多></router-link>
        </div>
        <div class="bor1"></div>
        <div class="bigdata">
          <div class="big">IP需求开发</div>
          <router-link style="color: #86909c; font-size: 14px" to="/demand">查看更多></router-link>
        </div>
        <div class="bor1"></div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import ListCard from "../components/ListCard.vue";
import { getRequest } from "../api/api";
import { formatDate, mapPropertyCategoryForRequest } from "../api/util";
import { setJWT, setUSER, getUSER, getJWT } from "../api/constant";

export default {
  components: { MyHead, MyFooter, ListCard },
  data() {
    return {
      editableTabsValue: "全部", //热点项目默认的tabs标签
      editableTabs: [
        "全部",
        "专利",
        "商业秘密",
        "商标",
        "版权",
        "集成电路",
        "其他",
      ], //热点项目
      tabPosition: "top", //标签方向
      input3: "", //受让输入框
      radio: "1", //单选按钮
      radio2: "",
      ness: [], //新闻
      topNes: {}, //头条新闻
      Noti: [], //公告
      topNoti: {}, //头条公告
      paneTabs: [
        {
          namePane: "新闻动态",
          idPane: 0,
        },
        {
          namePane: "公示公告",
          idPane: 1,
        },
      ],
      itemPane: "0", //新闻动态默认的tabs标签
      //资产
      surfac: [
        {
          image: require("@/assets/aa.png"),
          title: "累计知识产权挂牌总数",
          numb: "",
        },
        {
          image: require("@/assets/bb.png"),
          title: "累计知识产权交易总额",
          numb: "",
        },
        {
          image: require("@/assets/cc.png"),
          title: "联盟成员",
          numb: "",
        },
      ],
      // 轮播图
      chart: [],
      // 新闻轮播图
      Rotation: [
        { rota: require("@/assets/996.jpg") },
        { rota: require("@/assets/financialservice_01.png") },
        { rota: require("@/assets/Journalism.jpg") },
        { rota: require("@/assets/0.jpg") },
      ],
      //介绍
      introduction: [],
      imgList: [
        {
          img1: require("@/assets/20.png"),
          text: "生物医药",
          type: 0,
        },
        {
          img1: require("@/assets/21.png"),
          text: "人工智能",
          type: 2,
        },
        {
          img1: require("@/assets/22.png"),
          text: "航空航天",
          type: 3,
        },
        {
          img1: require("@/assets/23.png"),
          text: "新能源",
          type: 6,
        },
        {
          img1: require("@/assets/24.png"),
          text: "信息技术",
          type: 5,
        },
        {
          img1: require("@/assets/25.png"),
          text: "农业科技",
          type: 1,
        },
        {
          img1: require("@/assets/26.png"),
          text: "集成电路",
          type: 4,
        },
        {
          img1: require("@/assets/27.png"),
          text: "新材料",
          type: 7,
        },
      ],
      //服务保障
      service: [
        {
          image: require("@/assets/11.png"),
          text1: "智慧知产服务",
          url: "http://sh.publicdi.com/patent/table.html",
        },
        {
          image: require("@/assets/12.png"),
          text1: "知识产权质押融资",
          url: "/financialservice",
        },
        {
          image: require("@/assets/13.png"),
          text1: "上海专利运营BI",
          url: "http://sh.publicdi.com/BigScreen/shanghai.htm",
        },
        {
          image: require("@/assets/14.png"),
          text1: "开放许可",
          url: "/openlist",
        },
      ],
    };
  },
  methods: {
    // 跳转外部链接
    toUrl(url) {
      if (url.indexOf("http") != -1) window.open(url);
      else this.$router.push(url);
    },
    // 跳转重要产业
    toKey(n) {
      this.$router.push({
        path: "/keyindustries",
        query: { type: n },
      });
    },
    // 获取轮播图列表
    getchart() {
      getRequest({ url: "/api/v1/slider-image/list?type=ip" }).then((res) => {
        this.chart = res.data;
      });
    },
    // 获取挂牌总数,交易总额,机构数量
    getThere() {
      getRequest({ url: "/api/v1/markRelease/count" }).then((res) => {
        this.surfac[0].numb =
          res.data.totalCount + "<span style='font-size:20px'> 宗</span>";

        this.surfac[1].numb =
          "¥ " +
          res.data.totalPrice +
          "<span style='font-size:20px'> 万元</span>";

        this.surfac[2].numb =
          res.data.totalFacility + "<span style='font-size:20px'> 家</span>";
      });
    },
    // 专利搜索
    searchInput3() {
      console.log(this.input3);
      this.$router.push({
        path: "/seemore",
        name: "seemore",
        query: {
          value: this.input3,
        }
      });
    },
    // 热点项目列表接口
    patentList() {
      // 清空
      this.introduction = [];
      let data = {
        propertyCategory: mapPropertyCategoryForRequest(this.editableTabsValue),
        page: 1,
        size: 9,
      };
      if (data.propertyCategory == "全部") {
        delete data.propertyCategory;
      }
      getRequest({ url: "/api/v1/markRelease/list", data }).then((res) => {
        if (res.errcode == 200) {
          this.introduction = res.data;
        }
      });
    },
    tabs() {
      this.patentList();
    },
    // 新闻列表接口
    newsList() {
      let data = {
        page: 0,
        size: 5,
        category: 0,
      };
      getRequest({ url: "/api/v1/markRelease/newsPage", data }).then((res) => {
        if (res.errcode == 200) {
          this.topNes = res.data[0] || {};
          this.ness = res.data.slice(1, 5) || [];
        }
      });
    },
    // 公告接口
    notiList() {
      let data = {
        page: 0,
        size: 5,
      };
      getRequest({ url: "/api/v1/markRelease/bulletinPage", data }).then(
        (res) => {
          if (res.errcode == 200) {
            this.topNoti = res.data[0] || {};
            this.Noti = res.data.slice(1, 5) || [];
          }
        }
      );
    },
    tabpane() {
      console.log("切换");
    },
    int(item) {
      this.$router.push({
        path: "/details",
        query: { id: item },
      });
    },
    seemore() {
      this.$router.push({
        path: "/seemore",
      });
    },
    // 我要转让弹框
    //判断登入，如果没有登录弹框登入，登录以后再跳转，getJWT获取token，getUSER获取用户信息
    Way() {
      if (getUSER() && getJWT()) {
        this.$router.push({
          path: "/my",
        });
      } else if (this.$store.state.user && getUSER()) {
        this.$router.push({
          path: "/my",
        });
      } else {
        this.$login({
          login: (data) => {
            if (data) {
              // 登录回调函数
              this.$store.commit("setUser", data);
              console.warn("南方第三款耐腐蚀 ", getUSER());
              this.$router.push({
                path: "/my",
              });
            }
          },
        });
      }
    },
  },
  //过滤器
  filters: {
    formatDate(val) {
      return formatDate(val);
    },
  },
  created() {
    this.patentList();
    this.newsList();
    this.notiList();
    this.getchart();
    this.getThere();
  },
};
</script>

<style scoped lang="scss">
.gray_shadow:hover {
  transition: box-shadow 0.3s, border-color 0.3s;
  visibility: visible;
  box-shadow: 0px 0px 20px #ccc;
}

.imgs1:hover {
  transition: box-shadow 0.3s, border-color 0.3s;
  visibility: visible;
  box-shadow: 0px 0px 15px #aaa;
}

.list_card> :nth-child(3n) {
  margin-right: 0;
}

.list_card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e6eb;
  width: 31%;
  padding: 16px 20px;
  margin-top: 24px;
  cursor: pointer;

  // margin-right: 2px;
  .ming_cheng {
    font-size: 12px;
    font-weight: 400;
    color: #4e5969;

    span {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: #f2f3f5;
      border-radius: 50%;
      margin-right: 8px;
    }
  }

  .jia_ge {
    font-size: 18px;
    font-weight: 500;
    color: #eb5757;

    span {
      display: inline-block;
      height: 20px;
      font-size: 12px;
      font-weight: 400;
      color: #eb5757;
      background: #ffece8;
      padding: 0 6px;
      margin-right: 8px;
    }
  }

  .biao_qian {
    font-size: 12px;
    font-weight: 400;
    color: #86909c;
    padding: 16px 0;
    margin-bottom: 18px;
    border-bottom: 1px solid #e5e6eb;

    &>div {
      height: 20px;
      background: #f2f3f5;
      border-radius: 2px 2px 2px 2px;
      padding: 0 6px;
      margin-right: 8px;
    }

    .checked {
      color: #165dff;
      background: #e8f3ff;
    }
  }

  .zhuan_li_hao {
    font-size: 12px;
    font-weight: 400;
    color: #a9aeb8;
    margin-bottom: 16px;
  }

  .biao_ti {
    font-size: 18px;
    font-weight: 500;
    color: #1d2129;
    line-height: 28px;
  }

  .jie_shao {
    font-size: 12px;
    font-weight: 400;
    color: #86909c;
    line-height: 20px;
  }

  .img {
    width: 100px;
    height: 100px;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e5e6eb;
    margin-left: 10px;

    img {
      width: 100%;
      max-height: 100%;
    }
  }
}

.span {
  color: #86909c;
}

.picture {
  word-break: break-all;
  margin-left: 24px;
}

.empty {
  width: 24px;
  height: 24px;
  background: #f2f3f5;
  border-radius: 29px;
}

.roomturn {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.turn {
  width: 162px;
  height: 52px;
  font-size: 16px;
  background-color: #ffffff;
  border-radius: 8px 8px 8px 8px;
  color: #27ae60;
  border: 2px solid #27ae60;
  cursor: pointer;

  img {
    margin-right: 8px;
    width: 20px;
    height: 20px;
    background-color: #ffffff;
  }

  .turndiv {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 13px;

    div {
      height: 24px;
    }
  }
}

.room {
  width: 261.5px;
  height: 52px;
  font-size: 16px;
  background-color: #27ae60;
  border-radius: 8px 8px 8px 8px;
  color: #ffffff;
  cursor: pointer;

  img {
    margin-right: 8px;
    width: 20px;
    height: 20px;
    background-color: #ffffff;
  }

  .roomdiv {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 14px;

    div {
      height: 24px;
    }
  }
}

.bll {
  $bllH: 25vw;
  width: 100%;
  height: $bllH;
  background-size: 100% 100%;

  .el-carousel__container {
    height: $bllH;
  }

  img {
    width: 100%;
    height: $bllH;
    background-size: 100% 100%;
  }
}

.boo {
  // width: 96.3%;
  height: 348px;
  background-size: 100% 100%;
  padding-right: 24px;

  img {
    width: 100%;
    height: 348px;
    background-size: 100% 100%;
    border-radius: 12px 12px 12px 12px;
  }
}

.bor2 {
  margin-top: 24px;
  border-bottom: 1px solid #e5e6eb;
}

.bor1 {
  border-bottom: 1px solid #e5e6eb;
}

.inp {
  width: 217px;
}

.big {
  font-size: 16px;
  line-height: 1.5;
  color: #1d2129;
  font-weight: 500;
  margin-left: 24px;

  a {
    cursor: pointer;
  }
}

.bigdata {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 0 24px 0;
  font-weight: 500;

  a {
    text-decoration: none;
  }
}

.recommend {
  width: 31.5%;
  font-size: 16px;
  line-height: 24px;
}

.industry2 {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
}

.industry {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
}

// .industry > :nth-child(4n) {
//     margin-right: 0;
// }

.keyind {
  width: 79.17%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 185px;
}

.akey {
  width: 65.7%;
  // margin-left: 150px;
  // margin-right: 32px;
}

.locat {
  position: absolute;
  bottom: 28px;
  left: 48px;
}

.imgs1 {
  width: 21.56%;
  height: 188px;
  background-size: 100% 100%;
  position: relative;
  border-radius: 8px;
  margin-top: 24px;
  // margin-right: 24px;
  cursor: pointer;
}

.overseas {
  width: 79.17%;
  display: flex;
  // padding: 0 150px 48px 150px;
  margin: 0 auto;
  padding-bottom: 48px;
  justify-content: space-between;
  cursor: pointer;
}

.Serntee {
  width: 100%;
  background-color: #f7f8fa;
}

.guarantee {
  display: flex;
  align-items: center;
  padding: 24px 0;
  justify-content: center;
}

.blank {
  width: 23.51px;
  height: 23.5px;
  // font-size: 12px;
  // color: #fff;
  // line-height: 2;

  // text-align: center;
  // background-color: #165dff;
}

.service {
  text-align: center;
  width: 22.9%;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 24px 0;

  img {
    display: inline-block;
  }
}

.focusNews {
  width: 57.2%;
  margin: 24px 0;
  padding-right: 24px;
}

.news {
  width: 96.3%;
  display: flex;
  font-size: 12px;
  align-items: center;
  line-height: 2;
}

.focus {
  width: 96.3%;
  font-size: 20px;
  color: #1d2129;
  line-height: 2;
}

.notice {
  /* width: 24px; */
  padding: 0 6px;
  margin-bottom: 10px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  color: #eb5757;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #ffece8;
}

.adve {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 8px;
  padding-right: 8px;
}

.seme {
  display: flex;
  margin-bottom: 8px;
}

.topping {
  width: 37.9%;
  padding: 24px 0 24px 24px;
}

.advess {
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #333333;
  cursor: pointer;

  .advess_title {
    font-size: 16px;
    font-weight: 400;
    color: #1d2129;
    line-height: 24px;
    height: 48px;
  }
}

.sement {
  width: 100%;
  display: flex;
  margin-bottom: 8px;
}

.adverti {
  width: 79.17%;
  display: flex;
  justify-content: space-between;
  border: 1px solid #e5e6eb;
  margin: 0 auto;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 80px;
  margin-top: 24px;
}

.bargaining {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Price {
  display: flex;
}

.ren {
  font-size: 18px;
  color: #eb5757;
}

.discount {
  background-color: #ffece8;
  padding: 4px 6px;
  color: #eb5757;
}

.bor {
  border-bottom: 1px solid #e5e6eb;
  margin: 16px 0;
}

.inventi {
  width: 216px;
  display: flex;
  color: #86909c;
  justify-content: space-between;
}

.text4 {
  font-weight: 400;
  color: #86909c;
  line-height: 20px;
  word-wrap: break-word;
}

.text3 {
  font-size: 18px;
  font-weight: 500;
  color: #1d2129;
  line-height: 28px;
  word-wrap: break-word;
  margin-bottom: 4px;
}

.title {
  width: 209px;
  margin-right: 10px;
}

.special {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.patent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #a9aeb8;
  margin-bottom: 16px;
}

.red {
  padding: 2px 3px;
  line-height: 20px;
  border-radius: 2px 2px 2px 2px;
  background-color: #eb5757;
  color: #ffffff;
  font-size: 12px;
}

.three {
  font-size: 12px;
  padding: 16px 20px 20px 20px;
}

.two2 {
  width: 31.5%;
  // margin-right: 32px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e6eb;
  margin-bottom: 24px;
  cursor: pointer;
  padding: 16px 20px;
  box-sizing: border-box;
}

.details {
  width: 79.17%;
  // padding: 16px 20px;
  margin: 0 auto;

  .no_card {
    width: 31%;
  }
}

.details> :nth-child(3n) {
  margin-right: 0;
}

.fire {
  height: 45px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.headlines {
  display: flex;
  width: 79.17%;
  justify-content: space-between;
  align-items: center;
  // height: 45px;
  // padding: 0 150px;
  margin: 0 auto;
  // padding-bottom: 24px;
  // margin-bottom: 30px;
}

.fors {
  width: 100%;
  display: flex;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #e5e6eb;
  padding: 24px;
  box-sizing: border-box;
  cursor: pointer;
}

.surfa {
  width: 31.4%;
  display: flex;
}

.surface {
  width: 79.17%;
  display: flex;
  margin: 0 auto;
  margin-bottom: 60px;
  justify-content: space-between;
}

.hot {
  width: 79.17%;
  padding: 0 15px;
}

.go {
  width: 118px;
  height: 52px;
  color: #fff;
  background-color: #27ae60;
}

.gogo {
  width: 239px !important;
  background-color: #f2f3f5;
}

.types {
  width: 225px;
  justify-content: space-between;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: #86909c;
}

.input {
  width: 100%;
  display: flex;
  margin-bottom: 12px;
  position: relative;
}

.imgpng {
  position: absolute;
  right: 128px;
  top: 18px;
}

.giveway {
  //   width: 29.3%;
  /* padding: 24px 24px 28px 0; */
  margin: 24px 24px 24px 0;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

.busine {
  width: 70%;
  /* padding: 24px 32px 24px 24px; */
  margin: 24px 24px 24px 24px;
}

.business {
  display: flex;
  width: 79.17%;
  // margin: 57px 150px 47px 150px;
  margin: auto;
  margin-top: 57px;
  margin-bottom: 48px;
  box-shadow: 0px 8px 24px 1px rgba(5, 42, 64, 0.05999999865889549);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #e5e6eb;
  /* padding: 24px; */
  justify-content: space-between;
}

.text2 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.text {
  width: 300px;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  margin-bottom: 24px;
}

.dropdown {
  padding-left: 109px;
  padding-right: 24px;
}

.radio {
  display: flex;
  align-items: center;
}

::v-deep .el-radio__inner {
  border: none;
  border-radius: 0;
  width: 0;
  height: 0;
}

::v-deep .el-tabs--top {
  margin: auto 0;
}

::v-deep .el-link--inner {
  font-size: 12px;
}

::v-deep .el-radio__label {
  font-size: 12px;
}

::v-deep .el-tabs__active-bar {
  background-color: #165dff;
  height: 3px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

::v-deep .el-tabs__item.is-active {
  color: #165dff;
}

::v-deep .el-tabs__item {
  color: #86909c;
  font-size: 16px;
  padding: 0;
  padding-right: 32px;
}

::v-deep .el-icon-search:before {
  content: none;
}

.search {
  font-size: 16px;
  width: 112px;
  height: 52px;
  text-align: center;
  border: 2px solid #165dff;
  color: #fff;
  background-color: #165dff;
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-with-select {
  border-radius: 8px 0px 0px 8px;
  /* border: 2px solid #165dff; */
  font-size: 16px;
}

::v-deep .el-input__inner {
  border: none;
  padding: 24px 5px;
  background-color: #f2f3f5;
  border: 2px solid #165dff;
  border-radius: 8px 0px 0px 8px;
}

::v-deep .el-button+.el-button {
  margin-left: 20px;
}

::v-deep .el-button:focus,
.el-button:hover {
  color: #165dff;
  border-color: #165dff;
  background-color: #ffffff;
}

::v-deep .el-button--mini,
.el-button--small {
  padding: 7px 16px;
}

::v-deep.el-dropdown {
  font-size: 14px;
  color: #1d2129;
  line-height: 22px;
}

.home {
  width: 100%;
  background-color: #fff;
}
</style>
